import axios from 'axios';
import configFile from "./configFile.json";

export default axios.create ({
    baseURL: configFile.tipoCambioURL
});